import { render, staticRenderFns } from "./SupervisionActivityHeader.vue?vue&type=template&id=f8721e38"
import script from "./SupervisionActivityHeader.vue?vue&type=script&lang=js"
export * from "./SupervisionActivityHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports